export const DEFAULT_DATA_TABLE_OPTIONS = {
  itemsPerPage: 20,
  page: 1,
  sortBy: [],
  sortDesc: [],
};
export const DATA_TABLE_WATCH_PROPS = ['page', 'itemsPerPage', 'sortBy', 'sortDesc'];
